"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledContainer = styled_components_1.default.ul `
  align-items: center;
  background: ${config_1.colors.midnight};
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  margin: 0;
  width: 250px;
  padding: 20px 0 0;

  @media ${config_1.device.tablet} {
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
  }
`;
